import React, { useState } from 'react'
import { Button, Modal, Image, Form, Grid } from 'semantic-ui-react'
import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'
import { Field, Form as FinalForm } from 'react-final-form'

import somethingAintRight from '../../assets/somethingAintRight.gif'
import { API_PRODUCT_NOTICES } from '../../consts'
import { to } from '../../utils/to'
import { toast } from 'react-toastify'

export const ProductNoticeModal = ({ productId }: any) => {
  const [open, setOpen] = useState(false)

  const kindOptions = [
    {
      key: 'discontinued',
      text: 'discontinued',
      value: 'discontinued',
    },
    {
      key: 'duplicate',
      text: 'duplicate',
      value: 'duplicate',
    },
  ]

  const validate = (values: any) => {
    const errors: { [key: string]: string } = {}

    if (!values?.kind) {
      errors.kind = 'Type is required'
    }

    if (values?.duplicateProductId && values.productId === values?.duplicateProductId) {
      errors.duplicateProductId = 'Duplicate product ID can not be the same as current product ID.'
    }

    return errors
  }

  const onSubmit = async (values: any) => {
    const payload = {
      notice: {
        product_id: values.productId,
        kind: values.kind,
        data: {
          active_product_id: parseInt(values.duplicateProductId),
          comment: values.comment,
        },
      },
    }

    const axiosRequestObj: AxiosRequestConfig = {
      url: API_PRODUCT_NOTICES,
      method: 'POST',
      withCredentials: true,
      data: payload,
      headers: { 'content-type': 'application/json' },
    }

    const [error] = await to<AxiosResponse, AxiosError>(axios(axiosRequestObj))

    if (error) {
      toast('Error while creating notice', {
        containerId: 'error',
      })
    } else {
      toast('Notice created', {
        containerId: 'default',
      })
    }

    setOpen(false)
  }

  return (
    <Modal
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}
      style={{
        margin: 'auto 15px',
      }}
      trigger={
        <Button style={{ marginRight: '10px' }} color="yellow">
          Mark Product {productId} As Needing Attention
        </Button>
      }
    >
      <Modal.Header>Create a product notice</Modal.Header>
      <Modal.Content>
        <Grid>
          <Grid.Row>
            <Grid.Column width={5}>
              <Image size="medium" src={somethingAintRight} />
            </Grid.Column>
            <Grid.Column width={11}>
              <FinalForm
                onSubmit={onSubmit}
                initialValues={{ productId: productId?.toString() }}
                validate={validate}
              >
                {({ handleSubmit, values }) => (
                  <Form onSubmit={handleSubmit}>
                    <Field name="productId" type="text">
                      {({ input }) => (
                        <Form.Field>
                          <label>Product ID</label>
                          <Form.Input fluid disabled {...input} />
                        </Form.Field>
                      )}
                    </Field>
                    <Field name="kind">
                      {({ input, meta }) => {
                        return (
                          <>
                            <Form.Select
                              label="Type"
                              required
                              selection
                              options={kindOptions}
                              value={input.value}
                              onChange={(_, { value }) => input.onChange(value)}
                              error={meta.touched && meta.error}
                            />
                          </>
                        )
                      }}
                    </Field>
                    {values.kind !== 'duplicate' && (
                      <Field name="comment">
                        {({ input }) => (
                          <Form.Field>
                            <label>Comment</label>
                            <Form.Input fluid {...input} />
                          </Form.Field>
                        )}
                      </Field>
                    )}
                    {values.kind === 'duplicate' && (
                      <Field name="duplicateProductId" type="number">
                        {({ input, meta }) => (
                          <Form.Field>
                            <label>Duplicate Product ID</label>
                            <Form.Input fluid {...input} error={meta.touched && meta.error} />
                          </Form.Field>
                        )}
                      </Field>
                    )}
                    <Button primary type="submit">
                      Create Notice
                    </Button>
                  </Form>
                )}
              </FinalForm>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Modal.Content>
    </Modal>
  )
}
